import { SessionData } from 'owa-service/lib/types/SessionData';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { InitialMailData, lazyGetInitialMailDataHx } from 'hx-initial-mail-data';
import { markFunction } from 'owa-performance';
import { trace, errorThatWillCauseAlert } from 'owa-trace';
import * as Schema from 'owa-graph-schema';

export const getInitialMailData = markFunction(
    async (sessionData: SessionData): Promise<InitialMailData | null> => {
        try {
            // For web, since schema conversion depends on feature flags which aren't
            // initialized yet, we wait to convert to gql schema until reading from the stash.
            if (isHostAppFeatureEnabled('initialMailData')) {
                const mailboxType: Schema.MailboxType = 'UserMailbox';
                let userIdentity = sessionData.owaUserConfig?.SessionSettings?.LogonEmailAddress;
                const rootFolderDefaultNameIndex = sessionData.owaUserConfig?.SessionSettings?.DefaultFolderNames?.indexOf(
                    'msgfolderroot'
                );
                let rootFolderDefaultServerId;
                if (rootFolderDefaultNameIndex && rootFolderDefaultNameIndex > -1) {
                    rootFolderDefaultServerId =
                        sessionData.owaUserConfig?.SessionSettings?.DefaultFolderIds?.[
                            rootFolderDefaultNameIndex
                        ];
                }

                if (!userIdentity) {
                    errorThatWillCauseAlert('getInitialMailData: SessionSettings not available');
                    userIdentity = 'no-smtp-address';
                }

                if (!rootFolderDefaultNameIndex) {
                    errorThatWillCauseAlert(
                        'getInitialMailData: RootFolder not available in defaultNames'
                    );
                }

                const mailboxSmtpAddress = userIdentity;
                const mailboxInfo = {
                    type: mailboxType,
                    userIdentity: userIdentity,
                    mailboxSmtpAddress: mailboxSmtpAddress,
                };
                return lazyGetInitialMailDataHx.importAndExecute(
                    mailboxInfo,
                    rootFolderDefaultServerId?.Id
                );
            }
        } catch (error) {
            trace.warn('getInitialMailData: ' + error.message);
        }

        return null;
    },
    'imd'
);
